import { Box, styled } from '@mui/material';

const FinishWorkBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-direction: row-reverse;
`;

export default FinishWorkBox;
